import { render, staticRenderFns } from "./toshare.vue?vue&type=template&id=41063c16&"
import script from "./toshare.vue?vue&type=script&lang=js&"
export * from "./toshare.vue?vue&type=script&lang=js&"
import style0 from "./toshare.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports